// React
import React, { Suspense } from 'react';

// Components & Hooks
import ConfirmEmail from './ConfirmEmail';
import Devices from './Devices/Devices';
import Enrollment from './Enrollment/Enrollment';
import Home from './Home';
import Login from './Login';
import MemberDetails from './MemberDetails/MemberDetails';
import PasswordReset from './PasswordReset';
import PasswordResetSend from './PasswordResetSend';
import Reports from './Reports/Reports';
import Settings from './Settings/Settings';
import Signup from './Signup';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import 'semantic-ui-less/semantic.less';
import Admin from './Admin/Admin';
import { GeneralParamsProvider } from './GeneralParams';
import { PageViewsProvider } from './PageViewsProvider';
import { StitchAuthProvider, useStitchAuth } from './StitchAuth';
import { StitchMembersProvider } from './StitchMembers';

window.YTConfig = {
  host: 'https://www.youtube.com',
};

App.propTypes = {};
export default function App() {
  const MemberAccess = React.lazy(() =>
    import('./MemberAccess/MemberAccess'),
  );

  const OneTimeAlert = React.lazy(() =>
    import('./AlertDoctor/OneTimeAlert'),
  );

  return (
    <StitchAuthProvider>
      <StitchMembersProvider>
        <PageViewsProvider>
          <GeneralParamsProvider>
            <Router>
              <Switch>
                <Route path="/confirmemail">
                  <ConfirmEmail />
                </Route>
                <Route path="/passwordreset">
                  <PasswordReset />
                </Route>
                <Route path="/passwordresetsend">
                  <PasswordResetSend />
                </Route>
                <Route path="/signup/:client">
                  <Signup />
                </Route>
                <Route path="/signup">
                  <Signup />
                </Route>
                <Route path="/login/:client">
                  <Login />
                </Route>
                <Route path="/login">
                  <Login />
                </Route>
                <Route path="/doctoralerts/:alertId">
                  <Suspense fallback={<div>Loading...</div>}>
                    <OneTimeAlert />
                  </Suspense>
                </Route>
                <Route path="/member-access/:memberToken">
                  <Suspense fallback={<div>Loading...</div>}>
                    <MemberAccess />
                  </Suspense>
                </Route>
                <PrivateRoute path="/settings">
                  <Settings />
                </PrivateRoute>
                <PrivateRoute path="/enrollment/:viewDefault">
                  <Enrollment />
                </PrivateRoute>
                <PrivateRoute path="/devices/:viewDefault">
                  <Devices />
                </PrivateRoute>
                <PrivateRoute path="/member-details/:memberId">
                  <MemberDetails />
                </PrivateRoute>
                <PrivateRoute path="/reports">
                  <Reports />
                </PrivateRoute>
                <PrivateRoute path="/admin">
                  <Admin />
                </PrivateRoute>
                <PrivateRoute path="/home/:viewDefault">
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/home">
                  <Home />
                </PrivateRoute>
                <Route path="*">
                  <Redirect to={{ pathname: '/login' }} />
                </Route>
              </Switch>
            </Router>
          </GeneralParamsProvider>
        </PageViewsProvider>
      </StitchMembersProvider>
    </StitchAuthProvider>
  );
}

function PrivateRoute({ children, ...rest }) {
  const { isLoggedIn } = useStitchAuth();

  if (isLoggedIn) {
    return <Route {...rest} render={() => children} />;
  } else {
    return (
      <Route
        {...rest}
        render={({ location }) => (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )}
      />
    );
  }
}
